"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const generateAmortizationTableInPdf_1 = __importDefault(require("../../../../app/abc/application/useCases/generateAmortizationTableInPdf"));
const useErrorModal_1 = __importDefault(require("../../../../app/shared/utils/useErrorModal"));
const useAbcInsurers_1 = require("../../../../hooks/useAbcInsurers");
const useUrl_1 = require("../../../../hooks/useUrl");
const useSimulationStore_1 = require("../../../../stores/useSimulationStore");
const useAbcStore_1 = require("../../../../stores/useAbcStore");
const animated_placeholder_vue_1 = __importDefault(require("../atoms/animated-placeholder.vue"));
const leading_step_vue_1 = __importDefault(require("../atoms/leading-step.vue"));
const insurance_card_vue_1 = __importDefault(require("../molecules/insurance-card.vue"));
const modal_vue_1 = __importDefault(require("./modal.vue"));
const loading_modal_vue_1 = __importDefault(require("../../../organisms/loading-modal.vue"));
const SessionRepository_1 = __importDefault(require("../../../../repositories/SessionRepository"));
const useSessionStore_1 = require("../../../../stores/useSessionStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'step-abc',
    setup(__props) {
        const store = (0, useSimulationStore_1.useSimulationStore)();
        const sessionStore = (0, useSessionStore_1.useSessionStore)();
        const abcStore = (0, useAbcStore_1.useAbcStore)();
        const modalOptions = (0, useErrorModal_1.default)(false);
        const { createCotizationUrl } = (0, useUrl_1.useUrl)();
        const insurers = (0, vue_2.ref)([]);
        const coverageModal = (0, vue_2.ref)(false);
        const termsAccepted = (0, vue_2.ref)(false);
        const downloading = (0, vue_2.ref)(false);
        const insurerSelected = (0, vue_2.ref)(null);
        const typeSelected = (0, vue_2.ref)("");
        const step = (0, vue_2.ref)(1);
        const cotizationUrl = (hasTable) => {
            return (createCotizationUrl({
                isIframe: store.iframe,
                webpage: store.distributor?.webpage,
                uuid: store.uuid,
                hasTable,
            }) ?? "#");
        };
        const { fetch, isLoading } = (0, useAbcInsurers_1.useAbcInsurers)();
        (0, vue_2.onBeforeMount)(async () => {
            insurers.value = await fetch({
                plazo: abcStore.plazo,
                powerTrain: store.powerTrain,
                slug: store.distributor?.webpage,
            });
        });
        const isDataReady = (0, vue_2.computed)(() => {
            return insurerSelected.value && termsAccepted.value;
        });
        const selectedInsurer = (0, vue_2.computed)(() => {
            return insurers.value?.filter((insurer) => insurer.PAQUETE === typeSelected.value);
        });
        const handleTypeSelect = (type) => {
            typeSelected.value = type;
            step.value = 2;
        };
        const handleInsurerSelected = (insurer) => {
            insurerSelected.value = insurer;
            abcStore.insurer = insurer;
            SessionRepository_1.default.addAbcToSession(store.uuid, {
                anticipo: abcStore.data?.quotation?.Anticipo,
                aseguradora: abcStore.insurer?.ASEGURADORA,
                cobertura_seguro: abcStore.insurer?.PAQUETE,
                comision_apertura: abcStore.data?.data.Commission,
                enganche: store.enganche,
                financiamiento: store.powerTrain?.price + abcStore.insurer?.PRIMA_TOTAL - abcStore.engancheAmount,
                financiera: "ABC",
                mensualidad: abcStore.data?.data.Rent,
                mensualidad_seguro: Math.floor((abcStore.insurer?.PRIMA_TOTAL - abcStore.insurer?.MULTIRECIBOS[0].PRIMA_TOTAL) / abcStore.plazo),
                pago_inicial: abcStore.data?.data.Commission + abcStore.engancheAmount + abcStore.insurer?.MULTIRECIBOS[0].PRIMA_TOTAL,
                pago_mensual_abc: abcStore.data?.data.Rent,
                plazo: store.plazo,
                tipo_cotizacion: "arrendamiento",
                valor_residual: abcStore.data?.data.ResidualValue,
                distribuidor: {
                    id: store.distributor?.id,
                },
                vehicle: {
                    exterior_color_id: store.exteriorColor?.id,
                    interior_color_id: store.interiorColor?.id,
                    power_train_id: store.powerTrain?.id,
                },
            })
                .then((response) => {
                sessionStore.id = response.id;
            })
                .catch((error) => {
                console.error(error);
            });
            step.value = 3;
        };
        (0, vue_2.watch)(typeSelected, () => {
            insurerSelected.value = null;
            abcStore.insurer = null;
        });
        const handleExport = async () => {
            try {
                downloading.value = true;
                const file = await (0, generateAmortizationTableInPdf_1.default)(abcStore.data, store.distributor, insurerSelected.value, abcStore.engancheAmount, store.powerTrain?.price, abcStore.plazo);
                file.save("Cotizacion-Finbe-ABC.pdf");
            }
            finally {
                downloading.value = false;
            }
        };
        const handleNewPage = () => {
            const params = new URLSearchParams();
            params.set("AnticipoComision", abcStore.data?.data.AdvanceCommision.toString());
            params.set("AnticipoRenta", abcStore.data?.data.AdvanceRent.toString());
            params.set("price", abcStore.data?.quotation.price.toString());
            params.set("Seguro", abcStore.insurer?.PRIMA_TOTAL.toString());
            params.set("Residual", abcStore.data?.quotation.Residual.toString());
            params.set("Plazo", abcStore.data?.quotation.Plazo.toString());
            params.set("Comision", abcStore.data?.data.Commission.toString());
            params.set("Admon", abcStore.data?.data.Admon.toString());
            params.set("DepositoGarantia", abcStore.data?.data.Deposit.toString());
            params.set("IVA", abcStore.data?.quotation.IVA.toString());
            params.set("IVARentas", abcStore.data?.quotation.IVARentas.toString());
            params.set("PagoMensual", abcStore.data?.data.Rent.toString());
            params.set("Anticipo", abcStore.data?.quotation.Anticipo.toString());
            params.set("insurancePolicy", abcStore.insurer?.ID_COTIZACION.toString());
            params.set("hyundaiKey", store.powerTrain?.aplics_eikos_id.toString());
            params.set("powerTrainId", store.powerTrain?.id?.toString());
            params.set("interiorColor", store.interiorColor?.id?.toString());
            params.set("exteriorColor", store.exteriorColor?.id?.toString());
            const isIframe = store.iframe ? "1" : "0";
            return `${window.location.origin}/${store.distributor?.webpage}/abc/${isIframe}/buro-de-credito?${params.toString()}`;
        };
        const step3 = (0, vue_2.ref)(null);
        (0, vue_2.onMounted)(() => {
            step3.value?.scrollIntoView({ behavior: "smooth", block: "center" });
        });
        return { __sfc: true, store, sessionStore, abcStore, modalOptions, createCotizationUrl, insurers, coverageModal, termsAccepted, downloading, insurerSelected, typeSelected, step, cotizationUrl, fetch, isLoading, isDataReady, selectedInsurer, handleTypeSelect, handleInsurerSelected, handleExport, handleNewPage, step3, AnimatedPlaceholder: animated_placeholder_vue_1.default, LeadingStep: leading_step_vue_1.default, InsuranceCard: insurance_card_vue_1.default, Modal: modal_vue_1.default, LoadingModal: loading_modal_vue_1.default };
    }
});
